/* eslint-disable */
// @ts-ignore
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
// @ts-ignore
import Home from '../views/Home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
